import React from "react";
import { useHistory } from "react-router-dom";

import Logo from "../components/Logo";
import { Container, Button } from "../components/wombat-ui";
import useTranslations from "../hooks/useTranslations";

const ErrorScreen = ({ label, logo = true }) => {
  const history = useHistory();
  const t = useTranslations();

  return (
    <Container className="w-screen h-screen" id="errorScreen">
      <div className="flex flex-col items-center justify-center flex-grow h-full space-y-4">
        {logo && <Logo />}
        <p className="text-xl text-dark-100">{label}</p>
        <Button className="mt-3" scale="md" onClick={() => history.goBack()} id="goBackButton">
          {t("header.goBack")}
        </Button>
      </div>
    </Container>
  );
};

export default ErrorScreen;
